import React from "react";
import ModuleBreadcrumbs from "components/ModuleBreadcrumbs";
import { Title } from "@skyportal/ui-kit";

import styles from "./styles.module.css";

export interface PageHeaderProps {
  title: string;
}

const PageHeader: React.FC<PageHeaderProps> = ({ title }) => {
  return (
    <header className={styles.root}>
      <div className={styles.header}>
        <ModuleBreadcrumbs />
        <Title level={2}>{title}</Title>
      </div>
    </header>
  );
};

export default PageHeader;
